<ng-template #emailrt let-r="result" let-t="term">
  <div class="item-search-select">
    <span class="item-dest">{{ r.surname }}, {{ r.forename }} {{ r.email }}</span>
  </div>
</ng-template>
<form #shareForm="ngForm">
  <div cdkTrapFocus aria-live="assertive">
    <div class="modal-header">
      <h3 class="modal-title" id="modal-header">
        @if (!displayItinerary) {
          <span i18n="@@modalShareBasketTitle">Share Basket With:</span>
        }
        @if (displayItinerary) {
          <span i18n="@@modalShareBasketTitleItinerary">Share Itinerary With:</span>
        }
        @if (displayItinerary) {
          <section class="container" (mouseleave)="ttItin.close()">
            <i
              class="ico-info"
              i18n-ngbTooltip
              #ttItin="ngbTooltip"
              triggers="manual"
              ngbTooltip="You are only able to share your itineraries with colleagues within your company."
              aria-label="You are only able to share your itineraries with colleagues within your company."
              (mouseenter)="ttItin.open()"
              (focus)="ttItin.open()"
              (blur)="ttItin.close()"
              tabindex="0"
              i18n-ngbTooltip="@@tooltipItineraries"
            ></i>
          </section>
        }
        @if (!displayItinerary) {
          <section class="container" (mouseleave)="ttBasket.close()">
            <i
              class="ico-info"
              i18n-ngbTooltip
              #ttBasket="ngbTooltip"
              triggers="manual"
              aria-label="You are only able to share your baskets with colleagues within your company."
              ngbTooltip="You are only able to share your baskets with colleagues within your company."
              (mouseenter)="ttBasket.open()"
              (focus)="ttBasket.open()"
              (blur)="ttBasket.close()"
              tabindex="0"
              i18n-ngbTooltip="@@tooltipBaskets"
            ></i>
          </section>
        }
      </h3>
      <button
        type="button"
        class="close"
        aria-label="Close"
        ngbAutoFocus
        (click)="activeModal.close()"
      >
        <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
      </button>
    </div>

    <div class="modal-body">
      <h4>Email</h4>
      @for (user of shareUsers; track user; let i = $index) {
        <div class="share-email-container">
          <input
            [attr.aria-label]="'Email to share - ' + (i + 1)"
            appInput
            [border]="true"
            i18n-placeholder
            placeholder="Enter an email to share with..."
            [ngbTypeahead]="searchTravellers"
            [resultTemplate]="emailrt"
            [inputFormatter]="userFormatter"
            i18n-placeholder
            [(ngModel)]="user.user"
            name="emailLookup{{ i }}"
            required
            [container]="body"
          />
          @if (i) {
            <button
              [attr.aria-label]="'Remove email to share - ' + (i + 1)"
              class="remove-email-button"
            >
              <i class="ico-cancel" aria-hidden="true" (click)="removeEmail(i)"></i>
            </button>
          }
        </div>
      }
      <button appButton="small" aria-label="Add another email" (click)="addAnotherEmail()">
        Add another email
      </button>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        aria-label="Cancel"
        appButton="small"
        class="small-button--close"
        (click)="activeModal.close()"
        (keydown.enter)="activeModal.close()"
        (keydown.space)="activeModal.close()"
        i18n="@@modalCancel"
      >
        Cancel
      </button>
      <button
        type="button"
        id="button_ok"
        appButton="small"
        aria-label="Share"
        i18n-aria-label
        [disabled]="!valid()"
        (click)="submit()"
        (keydown.enter)="submit()"
        (keydown.space)="submit()"
        i18n="@@modalShare"
      >
        Share
      </button>
    </div>
  </div>
</form>
